const LEGACYBROWSERS = {
  methods: {
    isLegacy() {
      const userAgent = window.navigator.userAgent
      return (userAgent.indexOf('Safari') > 0 && userAgent.indexOf('OS X') > 0) || userAgent.indexOf('Trident') > 0
    },
    isIOS() {
      const userAgent = window.navigator.userAgent
      return /iphone|ipod|ipad/.test(userAgent)
    },
    isEdge() {
      const userAgent = window.navigator.userAgent
      return userAgent.indexOf('Edge') > 0
    }
  }
}

export default LEGACYBROWSERS



// WEBPACK FOOTER //
// ./src/mixins/legacyBrowsers.js